import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";

const EmployeeSchema = Yup.object().shape({
  Name: Yup.string().required("Employee name is required"),
  F_FirmMaster: Yup.string().required("Firm is required"),
});

const emptyDeptRow    = () => ({ F_DepartmentMaster: "", F_DesignationMaster: "", EffectiveDate: "" });
const emptyShiftRow   = () => ({ F_ShiftMaster: "", EffectiveFrom: "" });
const emptyJoinRow    = () => ({ JoinDate: "", F_JoinTypeMaster: "", LeftDate: "", ReasonOfLeft: "" });
const emptySalaryRow  = () => ({ BasicSalary: "", GradePay: "", EffectiveDate: "", F_BasicTypeMaster: "" });
const emptyNomineeRow = () => ({ NomineeName: "", Address: "", F_RelationshipMaster: "", BirthDate: "", Amount: "", ParentName: "", AadharNo: "" });
const emptyRelativeRow= () => ({ RelativeName: "", DateOfBirth: "", Address: "", F_RelationshipMaster: "", LivingWith: 0, ForESI: 0, AadharNo: "" });
const emptyAllowanceRow=() => ({ F_AllowanceMaster: "", Amount: "", Calculation: "MANUAL", IsOnGross: false, IsPFApply: false, IsESIApply: false, IsRoundOffApply: false, IsWorkingDaysApply: false, IsApplicable: false, EffectiveFrom: "" });
const emptyDeductionRow=() => ({ F_DeductionMaster: "", Amount: "", Calculation: "MANUAL", IsOnGross: false, IsPFApply: false, IsESIApply: false, IsRoundOffApply: false, IsWorkingDaysApply: false, IsApplicable: false, EffectiveFrom: "" });

const AddEdit_EmployeeMaster = () => {
  const [activeTab, setActiveTab] = useState("basicInfo");

  // JSON table rows
  const [deptRows,      setDeptRows]      = useState([emptyDeptRow()]);
  const [shiftRows,     setShiftRows]     = useState([emptyShiftRow()]);
  const [joinRows,      setJoinRows]      = useState([emptyJoinRow()]);
  const [salaryRows,    setSalaryRows]    = useState([emptySalaryRow()]);
  const [nomineeRows,   setNomineeRows]   = useState([emptyNomineeRow()]);
  const [relativeRows,  setRelativeRows]  = useState([emptyRelativeRow()]);
  const [allowanceRows, setAllowanceRows] = useState([emptyAllowanceRow()]);
  const [originalAllowanceRows, setOriginalAllowanceRows] = useState([]);
  const [allowanceViewIndex, setAllowanceViewIndex] = useState({});
  const [expandedAllowances, setExpandedAllowances] = useState({});
  // Deduction states
  const [deductionRows, setDeductionRows] = useState([emptyDeductionRow()]);
  const [originalDeductionRows, setOriginalDeductionRows] = useState([]);
  const [deductionViewIndex, setDeductionViewIndex] = useState({});
  const [expandedDeductions, setExpandedDeductions] = useState({});

  const [state, setState] = useState({
    id: 0,
    formData: {
      F_FirmMaster: "",
      F_BranchMaster: "",
      SerialNo: "",
      Name: "",
      FatherName: "",
      EmployeeType: "",
      CardNo: "",
      Sex: "",
      DateOfBirth: "",
      DateOfRetire: "",
      MobileNo: "",
      PermanentAddress: "",
      PresentAddress: "",
      F_DepartmentMaster: "",
      F_DesignationMaster: "",
      Remark: "",
      // ESI
      ESIApplicable: false, ESINo: "", ESIJoiningDate: "", ESIOldEmployee: false,
      TICs: false, PICs: false, Accident: false,
      // PF
      PFApplicable: false, EmplrPFOverLimit: false, EmpleeDedOverLimit: false,
      PensionApplicable: false, PensionOverLimit: false, HigherPension: false,
      PFNo: "", UAN: "", PFJoinDate: "", ExtraPF: "", PFCalculationType: "Percentage",
      OldMemberPF: false, OldMemberPension: false, PrevPFNo: "", OldUAN: "", DateOfExitPr: "",
      PMRPY: false, PMGKY: false, ABRY: false, FixedPFSalary: "",
      // Weekly Holiday
      WeeklyHoliday: "",
      // Bank
      BankName: "", IFSCCode: "", BankAccountNo: "", NameAsBank: "",
      // Documents
      PanCardNo: "", NameAsPerPan: "",
      DrivingLicenceNo: "", DLExpiryDate: "", NameAsPerDL: "",
      PassportNo: "", PassportFrom: "", PassportTill: "", PassportName: "",
      IsInternationalEmployee: false, CountryOrigin: "", Nationality: "",
    },
    FirmMaster:       [],
    BranchMaster:     [],
    DepartmentMaster: [],
    DesignationMaster:[],
    ShiftMaster:      [],
    JoinTypeMaster:   [],
    BasicTypeMaster:  [],
    RelationshipMaster:[],
    AllowanceMaster:  [],
    DeductionMaster:  [],
    isProgress: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "EmployeeMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/EmployeeDataDynamic`;

  const selectedFirm = JSON.parse(localStorage.getItem("selectedFirm") || "{}");
  const firmId = selectedFirm.Id || 0;

  useEffect(() => {
    const fetchData = async () => {
      Fn_FillListData(dispatch, setState, "FirmMaster",        `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id/0`);
      Fn_FillListData(dispatch, setState, "DepartmentMaster",  `${API_WEB_URLS.MASTER}/0/token/DepartmentMaster/Id/0`);
      Fn_FillListData(dispatch, setState, "DesignationMaster", `${API_WEB_URLS.MASTER}/0/token/DesignationMaster/Id/0`);
      Fn_FillListData(dispatch, setState, "ShiftMaster",       `${API_WEB_URLS.MASTER}/0/token/ShiftMaster/Id/0`);
      Fn_FillListData(dispatch, setState, "JoinTypeMaster",    `${API_WEB_URLS.MASTER}/0/token/JoinTypeMaster/Id/0`);
      Fn_FillListData(dispatch, setState, "BasicTypeMaster",   `${API_WEB_URLS.MASTER}/0/token/BasicTypeMaster/Id/0`);
      Fn_FillListData(dispatch, setState, "RelationshipMaster",`${API_WEB_URLS.MASTER}/0/token/RelationshipMaster/Id/0`);
      Fn_FillListData(dispatch, setState, "AllowanceMaster",   `${API_WEB_URLS.MASTER}/0/token/AllowanceMasterForEmployeeEntry/TBL.F_FirmMaster/${firmId}`);
      Fn_FillListData(dispatch, setState, "DeductionMaster",   `${API_WEB_URLS.MASTER}/0/token/DeductionMaster/Id/0`);

      const Id = (location.state && location.state.Id) || 0;
      if (Id > 0) {
        const res = await Fn_FillListData(dispatch, setState, "Data", API_URL_EDIT + "/" + Id + "/" + firmId);

        if (res && res.length > 0) {
          const d = res[0];
          setState((prev) => ({
            ...prev,
            id: Id,
            formData: {
              F_FirmMaster:       d.F_FirmMaster || "",
              F_BranchMaster:     d.F_BranchMaster || "",
              SerialNo:           d.SerialNo || "",
              Name:               d.Name || "",
              FatherName:         d.FatherName || "",
              EmployeeType:       d.EmployeeType || "",
              CardNo:             d.CardNo || "",
              Sex:                d.Sex || "",
              DateOfBirth:        d.DateOfBirth ? d.DateOfBirth.substring(0, 10) : "",
              DateOfRetire:       d.DateOfRetire ? d.DateOfRetire.substring(0, 10) : "",
              MobileNo:           d.MobileNo || "",
              PermanentAddress:   d.PermanentAddress || "",
              PresentAddress:     d.PresentAddress || "",
              F_DepartmentMaster: d.F_DepartmentMaster || "",
              F_DesignationMaster:d.F_DesignationMaster || "",
              Remark:             d.Remark || "",
              // ESI
              ESIApplicable:       !!d.ESIApplicable,
              ESINo:               d.ESINo               || "",
              ESIJoiningDate:      d.ESIJoiningDate      ? d.ESIJoiningDate.substring(0, 10)      : "",
              ESIOldEmployee:      !!d.ESIOldEmployee,
              TICs:                !!d.TICs,
              PICs:                !!d.PICs,
              Accident:            !!d.Accident,
              // PF
              PFApplicable:        !!d.PFApplicable,
              EmplrPFOverLimit:    !!d.EmplrPFOverLimit,
              EmpleeDedOverLimit:  !!d.EmpleeDedOverLimit,
              PensionApplicable:   !!d.PensionApplicable,
              PensionOverLimit:    !!d.PensionOverLimit,
              HigherPension:       !!d.HigherPension,
              PFNo:                d.PFNo                || "",
              UAN:                 d.UAN                 || "",
              PFJoinDate:          d.PFJoinDate          ? d.PFJoinDate.substring(0, 10)          : "",
              ExtraPF:             d.ExtraPF             || "",
              PFCalculationType:   d.PFCalculationType   || "Percentage",
              OldMemberPF:         !!d.OldMemberPF,
              OldMemberPension:    !!d.OldMemberPension,
              PrevPFNo:            d.PrevPFNo            || "",
              OldUAN:              d.OldUAN              || "",
              DateOfExitPr:        d.DateOfExitPr        ? d.DateOfExitPr.substring(0, 10)        : "",
              PMRPY:               !!d.PMRPY,
              PMGKY:               !!d.PMGKY,
              ABRY:                !!d.ABRY,
              FixedPFSalary:       d.FixedPFSalary       || "",
              // Other
              WeeklyHoliday:       d.WeeklyHoliday       || "",
              BankName:            d.BankName            || "",
              IFSCCode:            d.IFSCCode            || "",
              BankAccountNo:       d.BankAccountNo       || "",
              NameAsBank:          d.NameAsBank          || "",
              PanCardNo:           d.PanCardNo           || "",
              NameAsPerPan:        d.NameAsPerPan        || "",
              DrivingLicenceNo:    d.DrivingLicenceNo    || "",
              DLExpiryDate:        d.DLExpiryDate        ? d.DLExpiryDate.substring(0, 10)        : "",
              NameAsPerDL:         d.NameAsPerDL         || "",
              PassportNo:          d.PassportNo          || "",
              PassportFrom:        d.PassportFrom        ? d.PassportFrom.substring(0, 10)        : "",
              PassportTill:        d.PassportTill        ? d.PassportTill.substring(0, 10)        : "",
              PassportName:        d.PassportName        || "",
              IsInternationalEmployee: !!d.IsInternationalEmployee,
              CountryOrigin:       d.CountryOrigin       || "",
              Nationality:         d.Nationality         || "",
              DepartmentJson:     d.DepartmentJson || "",
              ShiftJson:          d.ShiftJson || "",
              JoinJson:           d.JoinJson || "",
              SalaryJson:         d.SalaryJson || "",
              NomineeJson:        d.NomineeJson || "",
              RelativeJson:       d.RelativeJson || "",
              AllowanceJson:      d.AllowanceJson || "",
              DeductionJson:      d.DeductionJson || "",
            },
          }));
        }
      }
    };
    fetchData();
  }, [dispatch, location.state]);

  // Load branches when firm changes
  const handleFirmChange = (firmId, handleChange, e) => {
    handleChange(e);
    if (firmId) {
      Fn_FillListData(dispatch, setState, "BranchMaster", `${API_WEB_URLS.MASTER}/0/token/BranchMaster/F_FirmMaster/${firmId}`);
    } else {
      setState((prev) => ({ ...prev, BranchMaster: [] }));
    }
  };

  // Restore JSON rows when editing
  useEffect(() => {
    const f = state.formData;
    if (!f) return;
    const tryParse = (val, def) => { try { const p = JSON.parse(val); return Array.isArray(p) && p.length ? p : [def()]; } catch(_) { return [def()]; } };
    if (f.DepartmentJson)  setDeptRows(tryParse(f.DepartmentJson,  emptyDeptRow));
    if (f.ShiftJson)       setShiftRows(tryParse(f.ShiftJson,       emptyShiftRow));
    if (f.JoinJson)        setJoinRows(tryParse(f.JoinJson,        emptyJoinRow));
    if (f.SalaryJson)      setSalaryRows(tryParse(f.SalaryJson,    emptySalaryRow));
    if (f.NomineeJson)     setNomineeRows(tryParse(f.NomineeJson,  emptyNomineeRow));
    if (f.RelativeJson)    setRelativeRows(tryParse(f.RelativeJson, emptyRelativeRow));
    if (f.AllowanceJson) {
      const parsed = tryParse(f.AllowanceJson, emptyAllowanceRow);
      setAllowanceRows(parsed);
      setOriginalAllowanceRows(JSON.parse(JSON.stringify(parsed)));
    }
    if (f.DeductionJson) {
      const parsed = tryParse(f.DeductionJson, emptyDeductionRow);
      setDeductionRows(parsed);
      setOriginalDeductionRows(JSON.parse(JSON.stringify(parsed)));
    }
    if (f.F_FirmMaster) {
      Fn_FillListData(dispatch, setState, "BranchMaster", `${API_WEB_URLS.MASTER}/0/token/BranchMaster/F_FirmMaster/${f.F_FirmMaster}`);
    }
  }, [state.formData]);

  // Generic row helpers
  const addRow    = (setter, empty) => setter((p) => [...p, empty()]);
  const removeRow = (setter, index) => setter((p) => p.length === 1 ? p : p.filter((_, i) => i !== index));
  const changeRow = (setter, index, field, value) =>
    setter((p) => p.map((r, i) => i === index ? { ...r, [field]: value } : r));
  
  // Special handler for allowance calculation change - auto-set IsWorkingDaysApply to false for DAILY/PERCENTAGE
  const changeAllowanceCalculation = (index, calculation) => {
    setAllowanceRows(prev => prev.map((row, i) => {
      if (i !== index) return row;
      const updated = { ...row, Calculation: calculation };
      if (calculation === "DAILY" || calculation === "PERCENTAGE") {
        updated.IsWorkingDaysApply = false;
      }
      return updated;
    }));
  };

  // Deduction calculation change
  const changeDeductionCalculation = (index, calculation) => {
    setDeductionRows(prev => prev.map((row, i) => {
      if (i !== index) return row;
      const updated = { ...row, Calculation: calculation };
      if (calculation === "DAILY" || calculation === "PERCENTAGE") {
        updated.IsWorkingDaysApply = false;
      }
      return updated;
    }));
  };

  // Reusable +/- action cell (moved above for hoisting)
  const ActionCell = ({ index, rows, onAdd, onRemove }) => (
    <td className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
      <button type="button" className="btn btn-success btn-xs me-1" onClick={onAdd} title="Add"><i className="fa fa-plus" /></button>
      <button type="button" className="btn btn-danger btn-xs" onClick={() => onRemove(index)} disabled={rows.length === 1} title="Remove"><i className="fa fa-minus" /></button>
    </td>
  );

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      formData.append("F_FirmMaster",       values.F_FirmMaster     || 0);
      formData.append("F_BranchMaster",     values.F_BranchMaster   || 0);
      formData.append("SerialNo",           values.SerialNo         || 0);
      formData.append("Name",               values.Name);
      formData.append("FatherName",         values.FatherName       || "");
      formData.append("EmployeeType",       values.EmployeeType     || "");
      formData.append("CardNo",             values.CardNo           || "");
      formData.append("Sex",                values.Sex              || "");
      formData.append("DateOfBirth",        values.DateOfBirth      || "");
      formData.append("DateOfRetire",       values.DateOfRetire     || "");
      formData.append("MobileNo",           values.MobileNo         || "");
      formData.append("PermanentAddress",   values.PermanentAddress || "");
      formData.append("PresentAddress",     values.PresentAddress   || "");
      formData.append("F_DepartmentMaster", values.F_DepartmentMaster || 0);
      formData.append("F_DesignationMaster",values.F_DesignationMaster|| 0);
      formData.append("Remark",             values.Remark           || "");
      // ESI
      formData.append("ESIApplicable",       values.ESIApplicable);
      formData.append("ESINo",               values.ESINo               || "");
      formData.append("ESIJoiningDate",      values.ESIJoiningDate      || "");
      formData.append("ESIOldEmployee",      values.ESIOldEmployee);
      formData.append("TICs",                values.TICs);
      formData.append("PICs",                values.PICs);
      formData.append("Accident",            values.Accident);
      // PF
      formData.append("PFApplicable",        values.PFApplicable);
      formData.append("EmplrPFOverLimit",    values.EmplrPFOverLimit);
      formData.append("EmpleeDedOverLimit",  values.EmpleeDedOverLimit);
      formData.append("PensionApplicable",   values.PensionApplicable);
      formData.append("PensionOverLimit",    values.PensionOverLimit);
      formData.append("HigherPension",       values.HigherPension);
      formData.append("PFNo",                values.PFNo                || "");
      formData.append("UAN",                 values.UAN                 || "");
      formData.append("PFJoinDate",          values.PFJoinDate          || "");
      formData.append("ExtraPF",             values.ExtraPF             || 0);
      formData.append("PFCalculationType",   values.PFCalculationType   || "Percentage");
      formData.append("OldMemberPF",         values.OldMemberPF);
      formData.append("OldMemberPension",    values.OldMemberPension);
      formData.append("PrevPFNo",            values.PrevPFNo            || "");
      formData.append("OldUAN",              values.OldUAN              || "");
      formData.append("DateOfExitPr",        values.DateOfExitPr        || "");
      formData.append("PMRPY",               values.PMRPY);
      formData.append("PMGKY",               values.PMGKY);
      formData.append("ABRY",                values.ABRY);
      formData.append("FixedPFSalary",       values.FixedPFSalary       || 0);
      // Other
      formData.append("WeeklyHoliday",       values.WeeklyHoliday       || "");
      formData.append("BankName",            values.BankName            || "");
      formData.append("IFSCCode",            values.IFSCCode            || "");
      formData.append("BankAccountNo",       values.BankAccountNo       || "");
      formData.append("NameAsBank",          values.NameAsBank          || "");
      formData.append("PanCardNo",           values.PanCardNo           || "");
      formData.append("NameAsPerPan",        values.NameAsPerPan        || "");
      formData.append("DrivingLicenceNo",    values.DrivingLicenceNo    || "");
      formData.append("DLExpiryDate",        values.DLExpiryDate        || "");
      formData.append("NameAsPerDL",         values.NameAsPerDL         || "");
      formData.append("PassportNo",          values.PassportNo          || "");
      formData.append("PassportFrom",        values.PassportFrom        || "");
      formData.append("PassportTill",        values.PassportTill        || "");
      formData.append("PassportName",        values.PassportName        || "");
      formData.append("IsInternationalEmployee", values.IsInternationalEmployee);
      formData.append("CountryOrigin",       values.CountryOrigin       || "");
      formData.append("Nationality",         values.Nationality         || "");
      formData.append("DepartmentJson",     JSON.stringify(deptRows));
      formData.append("ShiftJson",         JSON.stringify(shiftRows));
      formData.append("JoinJson",           JSON.stringify(joinRows));
      formData.append("SalaryJson",         JSON.stringify(salaryRows));
      formData.append("NomineeJson",        JSON.stringify(nomineeRows));
      formData.append("RelativeJson",       JSON.stringify(relativeRows));

      // Allowance save logic
      const finalAllowance = [];
      allowanceRows.forEach((row) => {
        const orig = originalAllowanceRows.find(o => String(o.F_AllowanceMaster) === String(row.F_AllowanceMaster));
        if (orig) {
          const changed = Object.keys(row).some(k => String(row[k]) !== String(orig[k]));
          if (changed) {
            finalAllowance.push(orig);
          }
        }
        finalAllowance.push(row);
      });
      formData.append("AllowanceJson", JSON.stringify(finalAllowance));

      // Deduction save logic — only save rows where F_DeductionMaster is selected
      const finalDeduction = [];
      deductionRows.forEach((row) => {
        if (!row.F_DeductionMaster) return; // skip blank rows
        const orig = originalDeductionRows.find(o => String(o.F_DeductionMaster) === String(row.F_DeductionMaster));
        if (orig) {
          const changed = Object.keys(row).some(k => String(row[k]) !== String(orig[k]));
          if (changed) {
            finalDeduction.push(orig);
          }
        }
        finalDeduction.push(row);
      });
      formData.append("DeductionJson", JSON.stringify(finalDeduction));

      Fn_AddEditData(
        dispatch, setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE, true, "memberid", navigate, "/EmployeeMaster"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const tabs = [
    { key: "basicInfo",    label: "Basic Info" },
    { key: "department",   label: "Dept. History" },
    { key: "shift",       label: "Shift History" },
    { key: "join",         label: "Join History" },
    { key: "salary",       label: "Salary" },
    { key: "nominees",     label: "Nominees" },
    { key: "relatives",    label: "Relatives" },
    { key: "allowances",   label: "Allowances" },
    { key: "deductions",   label: "Deductions" },
  ];

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Employee Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Employee Master</h4>
            </div>
            <div className="card-body">

              {/* Tabs Nav */}
              <ul className="nav nav-tabs mb-4 flex-wrap" role="tablist">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.key}>
                    <button
                      className={`nav-link${activeTab === tab.key ? " active" : ""}`}
                      type="button"
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>

              <Formik
                initialValues={state.formData}
                enableReinitialize
                validationSchema={EmployeeSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => { handleSubmit(values); setSubmitting(false); }, 400);
                }}
              >
                {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>

                    {/* ── Tab 1: Basic Info ── */}
                    {activeTab === "basicInfo" && (
                      <div className="row">

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Firm *</label>
                          <select
                            className="form-control"
                            name="F_FirmMaster"
                            value={values.F_FirmMaster}
                            onBlur={handleBlur}
                            onChange={(e) => handleFirmChange(e.target.value, handleChange, e)}
                          >
                            <option value="">-- Select Firm --</option>
                            {state.FirmMaster.map((f) => <option key={f.Id} value={f.Id}>{f.Name}</option>)}
                          </select>
                          {errors.F_FirmMaster && <div className="text-danger fs-12">{errors.F_FirmMaster}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Branch</label>
                          <select
                            className="form-control"
                            name="F_BranchMaster"
                            value={values.F_BranchMaster}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Branch --</option>
                            {state.BranchMaster.map((b) => <option key={b.Id} value={b.Id}>{b.Name}</option>)}
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Serial No</label>
                          <input type="number" className="form-control" name="SerialNo" value={values.SerialNo} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Employee Name *</label>
                          <input type="text" className="form-control" name="Name" value={values.Name} onChange={handleChange} onBlur={handleBlur} />
                          {errors.Name && <div className="text-danger fs-12">{errors.Name}</div>}
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Father Name</label>
                          <input type="text" className="form-control" name="FatherName" value={values.FatherName} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Card No</label>
                          <input type="text" className="form-control" name="CardNo" value={values.CardNo} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Employee Type</label>
                          <select className="form-control" name="EmployeeType" value={values.EmployeeType} onChange={handleChange} onBlur={handleBlur}>
                            <option value="">-- Select --</option>
                            <option value="Permanent">Permanent</option>
                            <option value="Temporary">Temporary</option>
                            <option value="Contract">Contract</option>
                            <option value="Daily Wage">Daily Wage</option>
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Sex</label>
                          <select className="form-control" name="Sex" value={values.Sex} onChange={handleChange} onBlur={handleBlur}>
                            <option value="">-- Select --</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Date of Birth</label>
                          <input type="date" className="form-control" name="DateOfBirth" value={values.DateOfBirth ? values.DateOfBirth.split("T")[0] : ""} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Date of Retire</label>
                          <input type="date" className="form-control" name="DateOfRetire" value={values.DateOfRetire ? values.DateOfRetire.split("T")[0] : ""} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Mobile No</label>
                          <input type="text" className="form-control" name="MobileNo" value={values.MobileNo} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Department</label>
                          <select className="form-control" name="F_DepartmentMaster" value={values.F_DepartmentMaster} onChange={handleChange} onBlur={handleBlur}>
                            <option value="">-- Select Department --</option>
                            {state.DepartmentMaster.map((d) => <option key={d.Id} value={d.Id}>{d.Name}</option>)}
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Designation</label>
                          <select className="form-control" name="F_DesignationMaster" value={values.F_DesignationMaster} onChange={handleChange} onBlur={handleBlur}>
                            <option value="">-- Select Designation --</option>
                            {state.DesignationMaster.map((d) => <option key={d.Id} value={d.Id}>{d.Name}</option>)}
                          </select>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Permanent Address</label>
                          <textarea className="form-control" name="PermanentAddress" rows={2} value={values.PermanentAddress} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Present Address</label>
                          <textarea className="form-control" name="PresentAddress" rows={2} value={values.PresentAddress} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="text-label">Remark</label>
                          <textarea className="form-control" name="Remark" rows={2} value={values.Remark} onChange={handleChange} onBlur={handleBlur} />
                        </div>

                        {/* ── ESI / PF / Bank / Documents ── */}
                        <div className="col-md-12">
                          <div style={{ border: "1px solid #aac", borderRadius: 3, background: "#f0f4ff", padding: "8px 12px", fontSize: "12px" }}>

                            {/* ESI Row */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <strong style={{ minWidth: 95 }}>ESI Applicable:</strong>
                              <input type="checkbox" className="form-check-input mt-0" id="ESIApplicable" checked={!!values.ESIApplicable} onChange={e => setFieldValue("ESIApplicable", e.target.checked)} />
                              <label htmlFor="ESIApplicable" className="mb-0" style={{ fontSize: 12 }}>&nbsp;</label>
                              <span className="fw-semibold">ESI No:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 90 }} name="ESINo" value={values.ESINo || ""} onChange={handleChange} />
                              <span className="fw-semibold">ESI Joining Date:</span>
                              <input type="date" className="form-control form-control-sm" style={{ width: 145 }} name="ESIJoiningDate" value={values.ESIJoiningDate || ""} onChange={handleChange} />
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="ESIOldEmployee" checked={!!values.ESIOldEmployee} onChange={e => setFieldValue("ESIOldEmployee", e.target.checked)} /><label className="form-check-label" htmlFor="ESIOldEmployee">ESI Old Employee</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="TICs" checked={!!values.TICs} onChange={e => setFieldValue("TICs", e.target.checked)} /><label className="form-check-label" htmlFor="TICs">TICs</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="PICs" checked={!!values.PICs} onChange={e => setFieldValue("PICs", e.target.checked)} /><label className="form-check-label" htmlFor="PICs">PICs</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="Accident" checked={!!values.Accident} onChange={e => setFieldValue("Accident", e.target.checked)} /><label className="form-check-label" htmlFor="Accident">Accident</label></div>
                            </div>

                            {/* PF Flags Row */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <strong style={{ minWidth: 95 }}>PF Applicable:</strong>
                              <input type="checkbox" className="form-check-input mt-0" id="PFApplicable" checked={!!values.PFApplicable} onChange={e => setFieldValue("PFApplicable", e.target.checked)} />
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="EmplrPFOverLimit" checked={!!values.EmplrPFOverLimit} onChange={e => setFieldValue("EmplrPFOverLimit", e.target.checked)} /><label className="form-check-label" htmlFor="EmplrPFOverLimit">Empler PF Over limit</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="EmpleeDedOverLimit" checked={!!values.EmpleeDedOverLimit} onChange={e => setFieldValue("EmpleeDedOverLimit", e.target.checked)} /><label className="form-check-label" htmlFor="EmpleeDedOverLimit">Emplee Ded Over limit</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="PensionApplicable" checked={!!values.PensionApplicable} onChange={e => setFieldValue("PensionApplicable", e.target.checked)} /><label className="form-check-label" htmlFor="PensionApplicable">Pension</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="PensionOverLimit" checked={!!values.PensionOverLimit} onChange={e => setFieldValue("PensionOverLimit", e.target.checked)} /><label className="form-check-label" htmlFor="PensionOverLimit">Pension Over Lim</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="HigherPension" checked={!!values.HigherPension} onChange={e => setFieldValue("HigherPension", e.target.checked)} /><label className="form-check-label" htmlFor="HigherPension">Higher Pension</label></div>
                            </div>

                            {/* PF Details Row */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-semibold">PF No:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 90 }} name="PFNo" value={values.PFNo || ""} onChange={handleChange} />
                              <span className="fw-semibold">UAN:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 130 }} name="UAN" value={values.UAN || ""} onChange={handleChange} />
                              <span className="fw-semibold">Join Date:</span>
                              <input type="date" className="form-control form-control-sm" style={{ width: 145 }} name="PFJoinDate" value={values.PFJoinDate || ""} onChange={handleChange} />
                              <span className="fw-semibold">Extra PF:</span>
                              <input type="number" step="0.01" className="form-control form-control-sm" style={{ width: 90 }} name="ExtraPF" value={values.ExtraPF || ""} onChange={handleChange} />
                              <div className="form-check mb-0"><input className="form-check-input" type="radio" name="PFCalculationType" id="pfCalcPerc" value="Percentage" checked={values.PFCalculationType === "Percentage"} onChange={handleChange} /><label className="form-check-label" htmlFor="pfCalcPerc">Prec. %</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="radio" name="PFCalculationType" id="pfCalcManual" value="Manual" checked={values.PFCalculationType === "Manual"} onChange={handleChange} /><label className="form-check-label" htmlFor="pfCalcManual">Manual</label></div>
                            </div>

                            {/* Old Member Row */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-bold">Old Member</span>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="OldMemberPF" checked={!!values.OldMemberPF} onChange={e => setFieldValue("OldMemberPF", e.target.checked)} /><label className="form-check-label" htmlFor="OldMemberPF">PF</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="OldMemberPension" checked={!!values.OldMemberPension} onChange={e => setFieldValue("OldMemberPension", e.target.checked)} /><label className="form-check-label" htmlFor="OldMemberPension">Pension</label></div>
                              <span className="fw-semibold">Prev PF No.:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 130 }} name="PrevPFNo" value={values.PrevPFNo || ""} onChange={handleChange} />
                              <span className="fw-semibold">Old UAN:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 130 }} name="OldUAN" value={values.OldUAN || ""} onChange={handleChange} />
                              <span className="fw-semibold">Date of Exit Pr.:</span>
                              <input type="date" className="form-control form-control-sm" style={{ width: 145 }} name="DateOfExitPr" value={values.DateOfExitPr || ""} onChange={handleChange} />
                            </div>

                            {/* Schemes Row */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="PMRPY" checked={!!values.PMRPY} onChange={e => setFieldValue("PMRPY", e.target.checked)} /><label className="form-check-label fw-semibold" htmlFor="PMRPY">PMRPY</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="PMGKY" checked={!!values.PMGKY} onChange={e => setFieldValue("PMGKY", e.target.checked)} /><label className="form-check-label fw-semibold" htmlFor="PMGKY">PMGKY</label></div>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="ABRY" checked={!!values.ABRY} onChange={e => setFieldValue("ABRY", e.target.checked)} /><label className="form-check-label fw-semibold" htmlFor="ABRY">ABRY</label></div>
                              <span className="fw-semibold">Fixed PF Salary:</span>
                              <input type="number" step="0.01" className="form-control form-control-sm" style={{ width: 100 }} name="FixedPFSalary" value={values.FixedPFSalary || ""} onChange={handleChange} />
                            </div>

                            <hr className="my-1" />

                            {/* Weekly Holiday */}
                            <div className="d-flex align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-semibold" style={{ minWidth: 110 }}>Weekly Holiday:</span>
                              <select className="form-control form-control-sm" style={{ width: 160 }} name="WeeklyHoliday" value={values.WeeklyHoliday || ""} onChange={handleChange}>
                                <option value="">-- Select --</option>
                                <option value="Sunday">Sunday</option>
                                <option value="Monday">Monday</option>
                                <option value="Tuesday">Tuesday</option>
                                <option value="Wednesday">Wednesday</option>
                                <option value="Thursday">Thursday</option>
                                <option value="Friday">Friday</option>
                                <option value="Saturday">Saturday</option>
                              </select>
                            </div>

                            {/* Bank */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-semibold" style={{ minWidth: 75 }}>Bank Name:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 220 }} name="BankName" value={values.BankName || ""} onChange={handleChange} />
                            </div>
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-semibold">IFSC Code:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 120 }} name="IFSCCode" value={values.IFSCCode || ""} onChange={handleChange} />
                              <span className="fw-semibold">Bank A/c No.:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 160 }} name="BankAccountNo" value={values.BankAccountNo || ""} onChange={handleChange} />
                              <span className="fw-semibold">Name as Bank:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 170 }} name="NameAsBank" value={values.NameAsBank || ""} onChange={handleChange} />
                            </div>

                            {/* PAN */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-semibold">Pan Card No.:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 140 }} name="PanCardNo" value={values.PanCardNo || ""} onChange={handleChange} />
                              <span className="fw-semibold">Name as per Pan:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 200 }} name="NameAsPerPan" value={values.NameAsPerPan || ""} onChange={handleChange} />
                            </div>

                            {/* Driving Licence */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-semibold">Driving Licence No.:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 140 }} name="DrivingLicenceNo" value={values.DrivingLicenceNo || ""} onChange={handleChange} />
                              <span className="fw-semibold">D.L. Expiry Date:</span>
                              <input type="date" className="form-control form-control-sm" style={{ width: 145 }} name="DLExpiryDate" value={values.DLExpiryDate || ""} onChange={handleChange} />
                              <span className="fw-semibold">Name as per DL:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 170 }} name="NameAsPerDL" value={values.NameAsPerDL || ""} onChange={handleChange} />
                            </div>

                            {/* Passport */}
                            <div className="d-flex flex-wrap align-items-center mb-1" style={{ gap: "10px" }}>
                              <span className="fw-semibold">Passport No.:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 130 }} name="PassportNo" value={values.PassportNo || ""} onChange={handleChange} />
                              <span className="fw-semibold">Passport From:</span>
                              <input type="date" className="form-control form-control-sm" style={{ width: 145 }} name="PassportFrom" value={values.PassportFrom || ""} onChange={handleChange} />
                              <span className="fw-semibold">Passport Till:</span>
                              <input type="date" className="form-control form-control-sm" style={{ width: 145 }} name="PassportTill" value={values.PassportTill || ""} onChange={handleChange} />
                              <span className="fw-semibold">Name:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 160 }} name="PassportName" value={values.PassportName || ""} onChange={handleChange} />
                            </div>

                            {/* International */}
                            <div className="d-flex flex-wrap align-items-center" style={{ gap: "10px" }}>
                              <div className="form-check mb-0"><input className="form-check-input" type="checkbox" id="IsInternationalEmployee" checked={!!values.IsInternationalEmployee} onChange={e => setFieldValue("IsInternationalEmployee", e.target.checked)} /><label className="form-check-label fw-semibold" htmlFor="IsInternationalEmployee">International Employee</label></div>
                              <span className="fw-semibold">Country Origin:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 160 }} name="CountryOrigin" value={values.CountryOrigin || ""} onChange={handleChange} />
                              <span className="fw-semibold">Nationality:</span>
                              <input type="text" className="form-control form-control-sm" style={{ width: 140 }} name="Nationality" value={values.Nationality || ""} onChange={handleChange} />
                            </div>

                          </div>
                        </div>
                      </div>
                    )}

                    {/* ── Tab 2: Department History ── */}
                    {activeTab === "department" && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Department</th>
                              <th>Designation</th>
                              <th>Effective Date</th>
                              <th style={{ width: 85 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {deptRows.map((row, i) => (
                              <tr key={i}>
                                <td className="align-middle text-center">{i + 1}</td>
                                <td>
                                  <select className="form-control form-control-sm" value={row.F_DepartmentMaster} onChange={(e) => changeRow(setDeptRows, i, "F_DepartmentMaster", e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {state.DepartmentMaster.map((d) => <option key={d.Id} value={d.Id}>{d.Name}</option>)}
                                  </select>
                                </td>
                                <td>
                                  <select className="form-control form-control-sm" value={row.F_DesignationMaster} onChange={(e) => changeRow(setDeptRows, i, "F_DesignationMaster", e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {state.DesignationMaster.map((d) => <option key={d.Id} value={d.Id}>{d.Name}</option>)}
                                  </select>
                                </td>
                                <td>
                                  <input type="date" className="form-control form-control-sm" value={row.EffectiveDate ? row.EffectiveDate.split("T")[0] : ""} onChange={(e) => changeRow(setDeptRows, i, "EffectiveDate", e.target.value)} />
                                </td>
                                <ActionCell index={i} rows={deptRows} onAdd={() => addRow(setDeptRows, emptyDeptRow)} onRemove={(idx) => removeRow(setDeptRows, idx)} />
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* ── Tab 3: Shift History ── */}
                    {activeTab === "shift" && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Shift</th>
                              <th>Effective From</th>
                              <th style={{ width: 85 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {shiftRows.map((row, i) => (
                              <tr key={i}>
                                <td className="align-middle text-center">{i + 1}</td>
                                <td>
                                  <select className="form-control form-control-sm" value={row.F_ShiftMaster} onChange={(e) => changeRow(setShiftRows, i, "F_ShiftMaster", e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {state.ShiftMaster.map((s) => <option key={s.Id} value={s.Id}>{s.Name}</option>)}
                                  </select>
                                </td>
                                <td>
                                  <input type="date" className="form-control form-control-sm" value={row.EffectiveFrom ? row.EffectiveFrom.split("T")[0] : ""} onChange={(e) => changeRow(setShiftRows, i, "EffectiveFrom", e.target.value)} />
                                </td>
                                <ActionCell index={i} rows={shiftRows} onAdd={() => addRow(setShiftRows, emptyShiftRow)} onRemove={(idx) => removeRow(setShiftRows, idx)} />
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* ── Tab 4: Join History ── */}
                    {activeTab === "join" && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Join Date</th>
                              <th>Join Type</th>
                              <th>Left Date</th>
                              <th>Reason of Left</th>
                              <th style={{ width: 85 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {joinRows.map((row, i) => (
                              <tr key={i}>
                                <td className="align-middle text-center">{i + 1}</td>
                                <td><input type="date" className="form-control form-control-sm" value={row.JoinDate ? row.JoinDate.split("T")[0] : ""} onChange={(e) => changeRow(setJoinRows, i, "JoinDate", e.target.value)} /></td>
                                <td>
                                  <select className="form-control form-control-sm" value={row.F_JoinTypeMaster} onChange={(e) => changeRow(setJoinRows, i, "F_JoinTypeMaster", e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {state.JoinTypeMaster.map((j) => <option key={j.Id} value={j.Id}>{j.Name}</option>)}
                                  </select>
                                </td>
                                <td><input type="date" className="form-control form-control-sm" value={row.LeftDate ? row.LeftDate.split("T")[0] : ""} onChange={(e) => changeRow(setJoinRows, i, "LeftDate", e.target.value)} /></td>
                                <td><input type="text" className="form-control form-control-sm" value={row.ReasonOfLeft || ""} onChange={(e) => changeRow(setJoinRows, i, "ReasonOfLeft", e.target.value)} /></td>
                                <ActionCell index={i} rows={joinRows} onAdd={() => addRow(setJoinRows, emptyJoinRow)} onRemove={(idx) => removeRow(setJoinRows, idx)} />
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* ── Tab 5: Salary ── */}
                    {activeTab === "salary" && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Basic Salary</th>
                              <th>Grade Pay</th>
                              <th>Effective Date</th>
                              <th>Basic Type</th>
                              <th style={{ width: 85 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {salaryRows.map((row, i) => (
                              <tr key={i}>
                                <td className="align-middle text-center">{i + 1}</td>
                                <td><input type="number" step="0.01" className="form-control form-control-sm" value={row.BasicSalary} onChange={(e) => changeRow(setSalaryRows, i, "BasicSalary", e.target.value)} /></td>
                                <td><input type="number" step="0.01" className="form-control form-control-sm" value={row.GradePay} onChange={(e) => changeRow(setSalaryRows, i, "GradePay", e.target.value)} /></td>
                                <td><input type="date" className="form-control form-control-sm" value={row.EffectiveDate ? row.EffectiveDate.split("T")[0] : ""} onChange={(e) => changeRow(setSalaryRows, i, "EffectiveDate", e.target.value)} /></td>
                                <td>
                                  <select className="form-control form-control-sm" value={row.F_BasicTypeMaster} onChange={(e) => changeRow(setSalaryRows, i, "F_BasicTypeMaster", e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {state.BasicTypeMaster.map((b) => <option key={b.Id} value={b.Id}>{b.Name}</option>)}
                                  </select>
                                </td>
                                <ActionCell index={i} rows={salaryRows} onAdd={() => addRow(setSalaryRows, emptySalaryRow)} onRemove={(idx) => removeRow(setSalaryRows, idx)} />
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* ── Tab 6: Nominees ── */}
                    {activeTab === "nominees" && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Nominee Name</th>
                              <th>Relationship</th>
                              <th>Birth Date</th>
                              <th>Amount</th>
                              <th>Parent Name</th>
                              <th>Aadhar No</th>
                              <th>Address</th>
                              <th style={{ width: 85 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {nomineeRows.map((row, i) => (
                              <tr key={i}>
                                <td className="align-middle text-center">{i + 1}</td>
                                <td><input type="text" className="form-control form-control-sm" value={row.NomineeName} onChange={(e) => changeRow(setNomineeRows, i, "NomineeName", e.target.value)} /></td>
                                <td>
                                  <select className="form-control form-control-sm" value={row.F_RelationshipMaster} onChange={(e) => changeRow(setNomineeRows, i, "F_RelationshipMaster", e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {state.RelationshipMaster.map((r) => <option key={r.Id} value={r.Id}>{r.Name}</option>)}
                                  </select>
                                </td>
                                <td><input type="date" className="form-control form-control-sm" value={row.BirthDate ? row.BirthDate.split("T")[0] : ""} onChange={(e) => changeRow(setNomineeRows, i, "BirthDate", e.target.value)} /></td>
                                <td><input type="number" step="0.01" className="form-control form-control-sm" value={row.Amount} onChange={(e) => changeRow(setNomineeRows, i, "Amount", e.target.value)} /></td>
                                <td><input type="text" className="form-control form-control-sm" value={row.ParentName} onChange={(e) => changeRow(setNomineeRows, i, "ParentName", e.target.value)} /></td>
                                <td><input type="text" className="form-control form-control-sm" value={row.AadharNo} onChange={(e) => changeRow(setNomineeRows, i, "AadharNo", e.target.value)} /></td>
                                <td><input type="text" className="form-control form-control-sm" value={row.Address} onChange={(e) => changeRow(setNomineeRows, i, "Address", e.target.value)} /></td>
                                <ActionCell index={i} rows={nomineeRows} onAdd={() => addRow(setNomineeRows, emptyNomineeRow)} onRemove={(idx) => removeRow(setNomineeRows, idx)} />
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* ── Tab 7: Relatives ── */}
                    {activeTab === "relatives" && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead className="table-light">
                            <tr>
                              <th>#</th>
                              <th>Relative Name</th>
                              <th>Relationship</th>
                              <th>Date of Birth</th>
                              <th>Address</th>
                              <th>Aadhar No</th>
                              <th style={{ width: 80 }}>Living With</th>
                              <th style={{ width: 70 }}>For ESI</th>
                              <th style={{ width: 85 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {relativeRows.map((row, i) => (
                              <tr key={i}>
                                <td className="align-middle text-center">{i + 1}</td>
                                <td><input type="text" className="form-control form-control-sm" value={row.RelativeName} onChange={(e) => changeRow(setRelativeRows, i, "RelativeName", e.target.value)} /></td>
                                <td>
                                  <select className="form-control form-control-sm" value={row.F_RelationshipMaster} onChange={(e) => changeRow(setRelativeRows, i, "F_RelationshipMaster", e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {state.RelationshipMaster.map((r) => <option key={r.Id} value={r.Id}>{r.Name}</option>)}
                                  </select>
                                </td>
                                <td><input type="date" className="form-control form-control-sm" value={row.DateOfBirth ? row.DateOfBirth.split("T")[0] : ""} onChange={(e) => changeRow(setRelativeRows, i, "DateOfBirth", e.target.value)} /></td>
                                <td><input type="text" className="form-control form-control-sm" value={row.Address} onChange={(e) => changeRow(setRelativeRows, i, "Address", e.target.value)} /></td>
                                <td><input type="text" className="form-control form-control-sm" value={row.AadharNo} onChange={(e) => changeRow(setRelativeRows, i, "AadharNo", e.target.value)} /></td>
                                <td className="text-center align-middle">
                                  <input type="checkbox" checked={row.LivingWith === 1} onChange={(e) => changeRow(setRelativeRows, i, "LivingWith", e.target.checked ? 1 : 0)} />
                                </td>
                                <td className="text-center align-middle">
                                  <input type="checkbox" checked={row.ForESI === 1} onChange={(e) => changeRow(setRelativeRows, i, "ForESI", e.target.checked ? 1 : 0)} />
                                </td>
                                <ActionCell index={i} rows={relativeRows} onAdd={() => addRow(setRelativeRows, emptyRelativeRow)} onRemove={(idx) => removeRow(setRelativeRows, idx)} />
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* ── Tab 8: Allowances ── */}
                    {activeTab === "allowances" && (() => {
                      // Sort AllowanceMaster by Ordering ascending
                      const sortedAllowanceMaster = [...(state.AllowanceMaster || [])].sort((a, b) => (a.Ordering || 0) - (b.Ordering || 0));

                      // Group rows by F_AllowanceMaster, preserving indices
                      const groups = {};
                      allowanceRows.forEach((row, i) => {
                        const key = row.F_AllowanceMaster || `new_${i}`;
                        if (!groups[key]) groups[key] = [];
                        groups[key].push({ row, index: i });
                      });
                      // Sort each group by EffectiveFrom ascending so latest is last
                      Object.values(groups).forEach(g => g.sort((a, b) => (a.row.EffectiveFrom || "").localeCompare(b.row.EffectiveFrom || "")));

                      // Sort entries by F_AllowanceMaster's position in sortedAllowanceMaster
                      const sortedEntries = Object.entries(groups).sort(([keyA], [keyB]) => {
                        const indexA = sortedAllowanceMaster.findIndex(a => String(a.Id) === String(keyA));
                        const indexB = sortedAllowanceMaster.findIndex(a => String(a.Id) === String(keyB));
                        if (indexA === -1 && indexB === -1) return 0;
                        if (indexA === -1) return 1;
                        if (indexB === -1) return -1;
                        return indexA - indexB;
                      });

                      return (
                        <div>
                          {sortedEntries.map(([key, entries]) => {
                            const total = entries.length;
                            const viewIdx = allowanceViewIndex[key] ?? (total - 1); // default latest
                            const { row, index: i } = entries[viewIdx] || entries[total - 1];
                            const allowanceName = sortedAllowanceMaster.find(a => String(a.Id) === String(row.F_AllowanceMaster))?.Name || `Allowance`;
                            const isExpanded = !!expandedAllowances[key];

                            return (
                              <div key={key} className="card mb-2">
                                <div className="card-header py-2 d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center gap-2">
                                    <button type="button" className="btn btn-sm py-0 px-1" style={{ fontSize: "10px", lineHeight: 1 }}
                                      onClick={() => setExpandedAllowances(prev => ({ ...prev, [key]: !prev[key] }))}>
                                      {isExpanded ? "▼" : "▶"}
                                    </button>
                                    <strong>{allowanceName}</strong>
                                    {!isExpanded && (
                                      <small className="text-muted ms-2">
                                        Rate: {row.Amount || "-"} | {row.Calculation || "-"} | {row.EffectiveFrom ? row.EffectiveFrom.split("T")[0] : "-"}
                                        {row.IsPFApply ? " | PF" : ""}{row.IsESIApply ? " | ESI" : ""}{row.IsApplicable ? " | Active" : ""}
                                      </small>
                                    )}
                                    {total > 1 && (
                                      <span className="d-flex align-items-center gap-1 ms-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" disabled={viewIdx === 0}
                                          onClick={() => setAllowanceViewIndex(prev => ({ ...prev, [key]: viewIdx - 1 }))}>
                                          ◀
                                        </button>
                                        <small className="text-muted">{viewIdx + 1}/{total}</small>
                                        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" disabled={viewIdx === total - 1}
                                          onClick={() => setAllowanceViewIndex(prev => ({ ...prev, [key]: viewIdx + 1 }))}>
                                          ▶
                                        </button>
                                      </span>
                                    )}
                                  </div>
                                  <ActionCell index={i} rows={allowanceRows} onAdd={() => addRow(setAllowanceRows, emptyAllowanceRow)} onRemove={(idx) => removeRow(setAllowanceRows, idx)} />
                                </div>
                                {isExpanded && (
                                <div className="card-body py-2">
                                  <div className="row mb-2">
                                    <div className="col-md-6">
                                      <label className="form-label mb-0">NAME</label>
                                      <select className="form-control form-control-sm" value={row.F_AllowanceMaster} onChange={(e) => changeRow(setAllowanceRows, i, "F_AllowanceMaster", e.target.value)}>
                                        <option value="">-- Select --</option>
                                        {sortedAllowanceMaster.map((a) => <option key={a.Id} value={a.Id}>{a.Name}</option>)}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="row mb-2">
                                    <div className="col-md-3">
                                      <label className="form-label mb-0">DATE</label>
                                      <input type="date" className="form-control form-control-sm" value={row.EffectiveFrom ? row.EffectiveFrom.split("T")[0] : ""} onChange={(e) => changeRow(setAllowanceRows, i, "EffectiveFrom", e.target.value)} />
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-0">RATE</label>
                                      <input type="number" step="0.01" className="form-control form-control-sm" value={row.Amount} onChange={(e) => changeRow(setAllowanceRows, i, "Amount", e.target.value)} />
                                    </div>
                                  </div>
                                  <div className="row mb-2">
                                    <div className="col-md-6">
                                      <label className="form-label mb-0">CALCULATION</label>
                                      <div className="d-flex gap-3 mt-1">
                                        {["MANUAL", "PERCENTAGE", "DAILY"].map((opt) => (
                                          <div key={opt} className="form-check">
                                            <input className="form-check-input" type="radio" name={`calc_${i}`} id={`calc_${i}_${opt}`} value={opt} checked={row.Calculation === opt} onChange={(e) => changeAllowanceCalculation(i, e.target.value)} />
                                            <label className="form-check-label" htmlFor={`calc_${i}_${opt}`}>{opt}</label>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-1">
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`onGross_${i}`} checked={!!row.IsOnGross} onChange={(e) => changeRow(setAllowanceRows, i, "IsOnGross", e.target.checked)} /><label className="form-check-label" htmlFor={`onGross_${i}`}>ON GROSS</label></div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`pfApply_${i}`} checked={!!row.IsPFApply} onChange={(e) => changeRow(setAllowanceRows, i, "IsPFApply", e.target.checked)} /><label className="form-check-label" htmlFor={`pfApply_${i}`}>PF APPLY</label></div>
                                    </div>
                                  </div>
                                  <div className="row mb-1">
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`esiApply_${i}`} checked={!!row.IsESIApply} onChange={(e) => changeRow(setAllowanceRows, i, "IsESIApply", e.target.checked)} /><label className="form-check-label" htmlFor={`esiApply_${i}`}>ESI APPLY</label></div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`roundOff_${i}`} checked={!!row.IsRoundOffApply} onChange={(e) => changeRow(setAllowanceRows, i, "IsRoundOffApply", e.target.checked)} /><label className="form-check-label" htmlFor={`roundOff_${i}`}>ROUNDED OFF</label></div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    {/* Only show Working Days Apply for MANUAL calculation */}
                                    {row.Calculation === "MANUAL" && (
                                      <div className="col-md-3">
                                        <div className="form-check"><input className="form-check-input" type="checkbox" id={`workDays_${i}`} checked={!!row.IsWorkingDaysApply} onChange={(e) => changeRow(setAllowanceRows, i, "IsWorkingDaysApply", e.target.checked)} /><label className="form-check-label" htmlFor={`workDays_${i}`}>WORKING DAYS APPLY</label></div>
                                      </div>
                                    )}
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`applicable_${i}`} checked={!!row.IsApplicable} onChange={(e) => changeRow(setAllowanceRows, i, "IsApplicable", e.target.checked)} /><label className="form-check-label" htmlFor={`applicable_${i}`}>APPLICABLE</label></div>
                                    </div>
                                  </div>
                                </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}

                    {/* ── Tab 9: Deductions ── */}
                    {activeTab === "deductions" && (() => {
                      const groups = {};
                      deductionRows.forEach((row, i) => {
                        const key = row.F_DeductionMaster || `new_${i}`;
                        if (!groups[key]) groups[key] = [];
                        groups[key].push({ row, index: i });
                      });
                      Object.values(groups).forEach(g => g.sort((a, b) => (a.row.EffectiveFrom || "").localeCompare(b.row.EffectiveFrom || "")));

                      return (
                        <div>
                          <div className="mb-2 text-end">
                            <button type="button" className="btn btn-success btn-sm" onClick={() => addRow(setDeductionRows, emptyDeductionRow)}>
                              <i className="fa fa-plus" /> Add Deduction
                            </button>
                          </div>
                          {Object.entries(groups).map(([key, entries]) => {
                            const total = entries.length;
                            const viewIdx = deductionViewIndex[key] ?? (total - 1);
                            const { row, index: i } = entries[viewIdx] || entries[total - 1];
                            const deductionName = state.DeductionMaster.find(a => String(a.Id) === String(row.F_DeductionMaster))?.Name || "New Deduction";
                            const isExpanded = expandedDeductions[key] !== false; // default expanded

                            return (
                              <div key={key} className="card mb-2">
                                <div className="card-header py-2 d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center gap-2">
                                    <button type="button" className="btn btn-sm py-0 px-1" style={{ fontSize: "10px", lineHeight: 1 }}
                                      onClick={() => setExpandedDeductions(prev => ({ ...prev, [key]: !isExpanded }))}>
                                      {isExpanded ? "▼" : "▶"}
                                    </button>
                                    <strong>{deductionName}</strong>
                                    {!isExpanded && (
                                      <small className="text-muted ms-2">
                                        Rate: {row.Amount || "-"} | {row.Calculation || "-"} | {row.EffectiveFrom ? row.EffectiveFrom.split("T")[0] : "-"}
                                        {row.IsPFApply ? " | PF" : ""}{row.IsESIApply ? " | ESI" : ""}{row.IsApplicable ? " | Active" : ""}
                                      </small>
                                    )}
                                    {total > 1 && (
                                      <span className="d-flex align-items-center gap-1 ms-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" disabled={viewIdx === 0}
                                          onClick={() => setDeductionViewIndex(prev => ({ ...prev, [key]: viewIdx - 1 }))}>◀</button>
                                        <small className="text-muted">{viewIdx + 1}/{total}</small>
                                        <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" disabled={viewIdx === total - 1}
                                          onClick={() => setDeductionViewIndex(prev => ({ ...prev, [key]: viewIdx + 1 }))}>▶</button>
                                      </span>
                                    )}
                                  </div>
                                  <td className="text-center align-middle" style={{ whiteSpace: "nowrap" }}>
                                    <button type="button" className="btn btn-danger btn-xs" onClick={() => removeRow(setDeductionRows, i)} disabled={deductionRows.length === 1} title="Remove"><i className="fa fa-minus" /></button>
                                  </td>
                                </div>
                                {isExpanded && (
                                <div className="card-body py-2">
                                  <div className="row mb-2">
                                    <div className="col-md-6">
                                      <label className="form-label mb-0">NAME</label>
                                      <select className="form-control form-control-sm" value={row.F_DeductionMaster} onChange={(e) => changeRow(setDeductionRows, i, "F_DeductionMaster", e.target.value)}>
                                        <option value="">-- Select --</option>
                                        {state.DeductionMaster.map((a) => <option key={a.Id} value={a.Id}>{a.Name}</option>)}
                                      </select>
                                    </div>
                                  </div>
                                  <div className="row mb-2">
                                    <div className="col-md-3">
                                      <label className="form-label mb-0">DATE</label>
                                      <input type="date" className="form-control form-control-sm" value={row.EffectiveFrom ? row.EffectiveFrom.split("T")[0] : ""} onChange={(e) => changeRow(setDeductionRows, i, "EffectiveFrom", e.target.value)} />
                                    </div>
                                    <div className="col-md-3">
                                      <label className="form-label mb-0">RATE</label>
                                      <input type="number" step="0.01" className="form-control form-control-sm" value={row.Amount} onChange={(e) => changeRow(setDeductionRows, i, "Amount", e.target.value)} />
                                    </div>
                                  </div>
                                  <div className="row mb-2">
                                    <div className="col-md-6">
                                      <label className="form-label mb-0">CALCULATION</label>
                                      <div className="d-flex gap-3 mt-1">
                                        {["MANUAL", "PERCENTAGE", "DAILY"].map((opt) => (
                                          <div key={opt} className="form-check">
                                            <input className="form-check-input" type="radio" name={`dedcalc_${i}`} id={`dedcalc_${i}_${opt}`} value={opt} checked={row.Calculation === opt} onChange={(e) => changeDeductionCalculation(i, e.target.value)} />
                                            <label className="form-check-label" htmlFor={`dedcalc_${i}_${opt}`}>{opt}</label>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row mb-1">
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`dedonGross_${i}`} checked={!!row.IsOnGross} onChange={(e) => changeRow(setDeductionRows, i, "IsOnGross", e.target.checked)} /><label className="form-check-label" htmlFor={`dedonGross_${i}`}>ON GROSS</label></div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`dedpfApply_${i}`} checked={!!row.IsPFApply} onChange={(e) => changeRow(setDeductionRows, i, "IsPFApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dedpfApply_${i}`}>PF APPLY</label></div>
                                    </div>
                                  </div>
                                  <div className="row mb-1">
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`dedesiApply_${i}`} checked={!!row.IsESIApply} onChange={(e) => changeRow(setDeductionRows, i, "IsESIApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dedesiApply_${i}`}>ESI APPLY</label></div>
                                    </div>
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`dedroundOff_${i}`} checked={!!row.IsRoundOffApply} onChange={(e) => changeRow(setDeductionRows, i, "IsRoundOffApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dedroundOff_${i}`}>ROUNDED OFF</label></div>
                                    </div>
                                  </div>
                                  <div className="row">
                                    {row.Calculation === "MANUAL" && (
                                      <div className="col-md-3">
                                        <div className="form-check"><input className="form-check-input" type="checkbox" id={`dedworkDays_${i}`} checked={!!row.IsWorkingDaysApply} onChange={(e) => changeRow(setDeductionRows, i, "IsWorkingDaysApply", e.target.checked)} /><label className="form-check-label" htmlFor={`dedworkDays_${i}`}>WORKING DAYS APPLY</label></div>
                                      </div>
                                    )}
                                    <div className="col-md-3">
                                      <div className="form-check"><input className="form-check-input" type="checkbox" id={`dedapplicable_${i}`} checked={!!row.IsApplicable} onChange={(e) => changeRow(setDeductionRows, i, "IsApplicable", e.target.checked)} /><label className="form-check-label" htmlFor={`dedapplicable_${i}`}>APPLICABLE</label></div>
                                    </div>
                                  </div>
                                </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}

                    {/* ── Submit / Cancel ── */}
                    <div className="mt-4">
                      <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                        {isSubmitting ? "Saving..." : "Save"}
                      </button>
                      <button type="button" className="btn btn-danger light" onClick={() => navigate("/EmployeeMaster")}>
                        Cancel
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_EmployeeMaster;
